import React from 'react';

import CorsoDettaglioButton from "./CorsoDettaglioButton";

import {useSelector} from "react-redux";
import {dayJS, RUOLI} from "../../applicationConf";
import {useLocation} from "react-router-dom";
import {TIPO_CORSO} from "../../costanti";
import { isPwa } from '../../fanctionUtility';
import { useNavigate } from 'react-router-dom';


export const CorsoDettaglioContainer = (props) => {

    const navigate = useNavigate();
    const {pathname} = useLocation();

    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);

    const CONFIGURATION_RUOLO = RUOLI[ruoloScelto.toUpperCase()];

    const checkSuperAdmin = () => {
        if (CONFIGURATION_RUOLO.hasOwnProperty('SUPER_ADMIN')) {
            return pathname.startsWith(CONFIGURATION_RUOLO.SUPER_ADMIN.CONTEXT_ROUTES);
        } else {
            return false;
        }
    }

    const colorCourse = props.dati.tipoCorso === TIPO_CORSO.FORMAZIONE ? 'text-blue' :
        props.dati.tipoCorso === TIPO_CORSO.GARANZIA_GIOVANI ? 'text-success' :
            props.dati.tipoCorso === TIPO_CORSO.SERVIZIO_CIVILE ? 'text-orange' :
                props.dati.tipoCorso === TIPO_CORSO.COFO ? 'text-salmon' : '';

    return isPwa() ? (
        <div className={`card animate__animated animate__fadeIn ${isPwa() ? 'mb-2' : 'my-4'}`}
             style={checkSuperAdmin() ? {cursor: 'pointer'} : {}}
             onClick={() =>  navigate(`/corso/${props.dati?.id}/presenze?tab=allievi`)}>
            <div className="card-header text-o">
                <i className={`fa fa-address-card ${colorCourse}`}>&nbsp;</i>
                <b> {props.dati?.codice} </b>
            </div>
            <div className="card-body">
                <div className='row'>
                    <div className='col-12 col-sm-3 col-md-3 col-lg-3'>
                    {props.dati?.descrizione}
                    </div>
                </div>

                {!checkSuperAdmin() &&
                    (<CorsoDettaglioButton dati={props.dati}/>)}

            </div>
        </div>
    ) : (
        <div className='card shadowCustom animate__animated animate__fadeIn'
             style={checkSuperAdmin() ? {cursor: 'pointer'} : {}}
             onClick={() => checkSuperAdmin() && props.handlerNavigate != null && props.handlerNavigate(props.dati?.id)}>
            <div className="card-header text-o">
                <i className={`fa fa-address-card ${colorCourse}`}>&nbsp;</i>
                <b> {props.dati?.codice} - {props.dati?.descrizione} </b> ({props.dati?.dataInizio} - {props.dati?.dataFine})
            </div>
            <div className="card-body">
                <div className='row'>
                    <div className='col-12 col-sm-3 col-md-3 col-lg-3'>
                        <b>
                            <i className="fa fa-home">&nbsp;</i>
                            Ente :
                        </b>
                        <br/>
                        Codice fiscale : {props.dati?.ente.codiceFiscale} <br/>
                        Denominazione : {props.dati?.ente.descrizione}
                        <br/>
                    </div>

                    <div className='col-12 col-sm-3 col-md-3 col-lg-3'>
                        <b>
                            <i className="fa fa-flag">&nbsp;</i>
                            Sede :
                        </b>
                        <br/>
                        Descrizione : {props.dati?.sede.descrizione} <br/>
                        Indirizzo: {props.dati?.sede.indirizzo.via}, {props.dati?.sede.indirizzo.civico} CAP {props.dati?.sede.indirizzo.cap} (Loc. {props.dati?.sede.indirizzo.localita})
                    </div>
                </div>

                <p className="card-text">
                    <b>Data inizio: </b> {dayJS(props.dati?.dataInizio, 'YYYY-MM-DD').format('DD/MM/YYYY')} -&nbsp;
                    <b>Data
                        Fine:</b> {props.dati?.dataFine ? dayJS(props.dati?.dataFine, 'YYYY-MM-DD').format('DD/MM/YYYY') : null}
                </p>

                {!checkSuperAdmin() &&
                    (<CorsoDettaglioButton dati={props.dati}/>)}

            </div>
        </div>
    );
};

